interface MapProps{
    name: string;
    coordinates: any;
}

export const citiesInNigeria: MapProps[] = [
    { name: 'Lagos', coordinates: [6.5244, 3.3792] },
    { name: 'Abuja', coordinates: [9.0579, 7.4951] },
    { name: 'Kano', coordinates: [11.9966, 8.5246] },
  ];